import Bridge from "../components/bridge/Bridge";

export default function BridgeRoute() {
  return <Bridge />;
}
